import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { INVOICE_LIST_COLUMN_LABEL_I18N_KEY } from '../invoice-list/invoice-list.config';
import { useInvoiceListContext } from '../invoice.context';

export const InvoiceListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useInvoiceListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={INVOICE_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
